import React from "react";

const generateTimeSlots = () => {
  const slots = [];
  const now = new Date();
  let currentMinutes = now.getHours() * 60 + now.getMinutes();
  const endMinutes = 22 * 60;

  currentMinutes = Math.ceil(currentMinutes / 15) * 15;

  for (let i = currentMinutes; i <= endMinutes; i += 15) {
    const hours24 = Math.floor(i / 60);
    const minutes = String(i % 60).padStart(2, "0");

    const period = hours24 < 12 ? "AM" : "PM";
    const hours12 = hours24 % 12 || 12;

    slots.push(`${String(hours12).padStart(2, "0")}:${minutes} ${period}`);
  }

  return slots;
};

const CallbackTimeSelector = ({
  selectedDate,
  callbackTime,
  setCallbackTime,
  availableSlots = {},
  limit,
  isCustomSlots = false,
}) => {
  const timeSlots = generateTimeSlots();
  const currentAvailableSlots = availableSlots[selectedDate] || [];

  const handleTimeChange = (event) => setCallbackTime(event.target.value);
  return (
    <div className="time-select">
      <select
        name="callbackTime"
        value={callbackTime}
        onChange={handleTimeChange}
        placeholder="Select time"
        className="form-select shadow-none py-2 bg-white fs-6 border card-border rounded w-100 custom-placeholder"
        errorClass="error-text mt-1"
        size={limit || null}
      >
        <option value="" disabled>
          {isCustomSlots && currentAvailableSlots.length === 0 ? "Time slots unavailable" :"Select time"}
        </option>
        {!isCustomSlots && timeSlots.map((time) => (
          <option
            key={time}
            value={time}
            className="cursor-pointer"
          >
            {time}
          </option>
        ))}
        {isCustomSlots && currentAvailableSlots.map((time) => (
          <option
            key={time}
            value={time}
            className="cursor-pointer"
          >
            {time}
          </option>
        ))}
      </select>
    </div>
  );
};

export default CallbackTimeSelector;
